/* 1119 - collection grid: back image first, lifestyle shot on hover, discount
   chip, hover size row. Prices are read from what the theme already rendered;
   nothing is invented. */
(function () {
  var SEL = '.product-grid .text-block:has(.price)';

  function num(t) {
    var m = String(t || '').replace(/[^0-9.,]/g, '').replace(/,/g, '');
    var v = parseFloat(m);
    return isFinite(v) ? v : 0;
  }

  function chips() {
    var boxes;
    try { boxes = document.querySelectorAll(SEL); }
    catch (e) { return; }
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box.querySelector('.gtap-off')) continue;
      var now = box.querySelector('.price');
      var was = box.querySelector('.compare-at-price');
      if (!now || !was) continue;
      var n = num(now.textContent), w = num(was.textContent);
      if (!n || !w || w <= n) continue;
      var chip = document.createElement('span');
      chip.className = 'gtap-off';
      chip.setAttribute('aria-hidden', 'true');
      chip.textContent = '−' + Math.round((1 - n / w) * 100) + '%';
      box.appendChild(chip);
    }
  }

  /* Lead with the back of the garment. The theme drives which slide shows via
     aria-hidden, not DOM order, so reordering nodes does nothing - swap the two
     images' sources instead. The second slide also becomes the lifestyle photo,
     so the arrows walk print then worn. */
  function backFirst() {
    var KEYS = ['src', 'srcset', 'sizes', 'width', 'height'];
    var gals = document.querySelectorAll('.product-grid .card-gallery slideshow-slides');
    for (var i = 0; i < gals.length; i++) {
      var g = gals[i];
      if (g.getAttribute('data-gtap-back')) continue;
      g.setAttribute('data-gtap-back', '1');
      var vis = [];
      for (var j = 0; j < g.children.length && vis.length < 2; j++) {
        if (!g.children[j].hasAttribute('hidden')) vis.push(g.children[j]);
      }
      if (vis.length < 2) continue;
      var a = vis[0].querySelector('img'), b = vis[1].querySelector('img');
      if (!a || !b) continue;
      for (var k = 0; k < KEYS.length; k++) {
        var av = a.getAttribute(KEYS[k]), bv = b.getAttribute(KEYS[k]);
        if (av === null && bv === null) continue;
        if (bv === null) a.removeAttribute(KEYS[k]); else a.setAttribute(KEYS[k], bv);
        if (av === null) b.removeAttribute(KEYS[k]); else b.setAttribute(KEYS[k], av);
      }
      a.removeAttribute('loading');

      var url = hoverUrl(g);
      if (url) {
        b.removeAttribute('srcset');
        b.removeAttribute('sizes');
        b.setAttribute('src', url);
      }
    }
  }

  /* The card's own pictures are all served cropped square, so the browser cannot
     tell a flat mockup from a lifestyle photo. Liquid works it out and leaves the
     URL on the card in data-gtap-hover. */
  function hoverUrl(node) {
    var card = node.closest('.product-card') || node.closest('.product-grid__item');
    var tag = card && card.querySelector('[data-gtap-hover]');
    return tag ? tag.getAttribute('data-gtap-hover') : null;
  }

  /* Its own layer rather than the theme's slideshow: the inactive slides carry
     the hidden attribute, and a hidden element cannot be faded in. */
  function hoverImg() {
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
    var cards = document.querySelectorAll('.product-grid .product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('.gtap-hoverimg')) continue;
      var tag = card.querySelector('[data-gtap-hover]');
      var gal = card.querySelector('.card-gallery');
      if (!tag || !gal) continue;
      var img = document.createElement('img');
      img.className = 'gtap-hoverimg';
      img.setAttribute('alt', '');
      img.setAttribute('aria-hidden', 'true');
      img.setAttribute('loading', 'lazy');
      img.src = tag.getAttribute('data-gtap-hover');
      gal.appendChild(img);
    }
  }

  /* move the size row inside the image so it can slide up over it.
     Pointer devices only - on touch it stays in the flow under the card. */
  function sizes() {
    if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
    var bars = document.querySelectorAll('.product-grid [data-gtap-sizes]');
    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      if (bar.getAttribute('data-gtap-moved')) continue;
      var card = bar.closest('.product-card');
      var gal = card && card.querySelector('.card-gallery');
      if (!gal) continue;
      var wrap = bar.parentElement;
      gal.appendChild(bar);
      bar.setAttribute('data-gtap-moved', '1');
      if (wrap && wrap !== gal && wrap.children.length === 0) wrap.remove();
    }
  }

  function paint() { backFirst(); hoverImg(); chips(); sizes(); }

  function start() {
    paint();
    if (!window.MutationObserver) return;
    var host = document.querySelector('.product-grid-container') || document.body;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(paint, 60);
    }).observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
